import React from 'react';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { Checkbox, Col, Descriptions, Form, Input, Radio, Row, Switch, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { TOUR_TRASH_TRANSLATION } from '../../../../constants/define/translation';

interface SettingSectionProps {
  isHandleViewTourTrash: boolean;
}

export const SettingSection = (props: SettingSectionProps) => {
  const { t } = useTranslation(TOUR_TRASH_TRANSLATION);
  const { isHandleViewTourTrash } = props;
  return (
    <>
      <Descriptions title={t('tab.detail.form.setting.title')} />
      <Form.Item
        label={t('tab.detail.form.setting.frequency')}
        name="remindPushNotificationFrequency"
        rules={[{ required: true, message: t('tab.detail.form.validate.frequencyBlank') }]}
      >
        <Input
          type="number"
          min="1"
          max="100"
          placeholder={t('tab.detail.form.setting.frequency')}
          readOnly={isHandleViewTourTrash}
          disabled={isHandleViewTourTrash}
        />
      </Form.Item>
      <Form.Item label={t('tab.detail.form.setting.notification')} name="pushNotificationTo" initialValue={1}>
        <Radio.Group style={fullWidth} disabled={isHandleViewTourTrash}>
          <Row>
            <Col span={12}>
              <Radio value={1}>{t('tab.detail.form.setting.pushNotiToEligiblePlayers')}</Radio>
            </Col>
            <Col span={12}>
              <Radio value={0}>{t('tab.detail.form.setting.pushNotiToAll')}</Radio>
            </Col>
          </Row>
        </Radio.Group>
      </Form.Item>
      <Form.Item label={t('tab.detail.form.setting.email')} name="sendEmailTo" initialValue={1}>
        <Radio.Group style={fullWidth} disabled={isHandleViewTourTrash}>
          <Row>
            <Col span={12}>
              <Radio value={1}>{t('tab.detail.form.setting.sendEmailToEligiblePlayers')}</Radio>
            </Col>
            <Col span={12}>
              <Radio value={0}>{t('tab.detail.form.setting.sendEmailToAll')}</Radio>
            </Col>
          </Row>
        </Radio.Group>
      </Form.Item>
      <Form.Item label={t('tab.detail.form.setting.participation')} name="participationLevel" initialValue={[0]}>
        <Checkbox.Group style={fullWidth} disabled={isHandleViewTourTrash}>
          <Row>
            <Col span={12}>
              <Checkbox value={0}>{t('tab.detail.form.setting.participationLevelZero')}</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value={1}>{t('tab.detail.form.setting.participationLevelOne')}</Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Form.Item>
      <Row>
        <Col span={12}>
          <Form.Item
            name="pushNotificationAtLaunch"
            label={t('tab.detail.form.setting.pushNotificationAtLaunch')}
            valuePropName="checked"
            initialValue
          >
            <Switch disabled={isHandleViewTourTrash} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="sendEmailAtLaunch"
            label={t('tab.detail.form.setting.sendEmailAtLaunch')}
            valuePropName="checked"
            initialValue
          >
            <Switch disabled={isHandleViewTourTrash} />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item
        name="timeToPushNotificationBeforeEndDate"
        label={t('tab.detail.form.setting.reminder')}
        initialValue={2}
      >
        <Input
          type="number"
          min="0"
          max="48"
          placeholder={t('tab.detail.form.setting.reminderPushNotiPlaceholder')}
          step={1}
          suffix={
            <>
              <span className="right-5">hours</span>
              <Tooltip title={t('tab.detail.form.setting.reminderPushNotiPlaceholder')}>
                <QuestionCircleOutlined />
              </Tooltip>
            </>
          }
          readOnly={isHandleViewTourTrash}
          disabled={isHandleViewTourTrash}
        />
      </Form.Item>
      <Form.Item name="timeToSendEmailBeforeEndDate" initialValue={48}>
        <Input
          type="number"
          min="0"
          max="48"
          placeholder={t('tab.detail.form.setting.reminderSendEmailPlaceholder')}
          step={1}
          suffix={
            <>
              <span className="right-5">hours</span>
              <Tooltip title={t('tab.detail.form.setting.reminderSendEmailPlaceholder')}>
                <QuestionCircleOutlined />
              </Tooltip>
            </>
          }
          readOnly={isHandleViewTourTrash}
          disabled={isHandleViewTourTrash}
        />
      </Form.Item>
      <Form.Item
        label={
          <>
            <span style={{ marginRight: '5px' }}>{t('tab.detail.form.setting.autoClose')}</span>
            <Tooltip title={t('tab.detail.form.setting.autoCloseTooltip')}>
              <QuestionCircleOutlined />
            </Tooltip>
          </>
        }
        name="timeToAutoCloseAfterEndDate"
        initialValue={5}
      >
        <Input
          type="number"
          min="0"
          max="50"
          placeholder={t('tab.detail.form.setting.autoClosePlaceholder')}
          step={1}
          suffix="days"
          readOnly={isHandleViewTourTrash}
          disabled={isHandleViewTourTrash}
        />
      </Form.Item>
    </>
  );
};

const fullWidth = {
  width: '100%',
};
